import { NgModule } from '@angular/core';
import { SharedModule } from 'lib-trend-core';
import { AttendanceMessageHitsComponent } from './attendance-message-hits.component';

@NgModule({
  imports: [
    SharedModule,
  ],
  declarations: [
    AttendanceMessageHitsComponent,
  ],
  exports: [
    AttendanceMessageHitsComponent,
  ],
})
export class AttendanceMessageHitsModule { }
